// extracted by mini-css-extract-plugin
export default {"systemDetailsOverview":"SystemDetailsOverview_systemDetailsOverview__yh2At","block":"SystemDetailsOverview_block__zLJU8","blockDetails":"SystemDetailsOverview_blockDetails__hYuEr"};